module.exports = __webpack_public_path__ + "media/images/lb/267-5b3178bc1432625d86b6b26d74e345c5.svg";